import React, { useState, useEffect } from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons, TextInputField } from "../../../../../common-components";
import useWindowDimensions from "../../../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";

const ProxyManagement = ({
  companyInformation,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
}) => {
  const { width, height } = useWindowDimensions();
  const [idAddPopUp, setIdAddPopUp] = useState(false);

  const [selectedId, setSelectedId] = useState(null);

  // function goes here for adding a new id to a business

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        position: "relative",
      }}
    >
      <div
        style={{
          width: "100%",
          minHeight: 55,
          backgroundColor: colors.white,
          display: "flex",
          alignItems: "center",
          marginTop: 5,
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            color: colors.secondaryDarkBlue,
            marginLeft: 20,
            fontSize: 20,
          }}
        >
          PROXY MANAGEMENT TOOLS
        </div>
        <div style={{ flex: 1 }} />
        <BaseButtons
          label={"+ ADD PROXY"}
          width={120}
          borderRadius={4}
          backgroundColor={colors.secondaryDarkBlue}
          onClick={() => setIdAddPopUp(true)}
        />
        <div style={{ minWidth: 10 }} />
      </div>
      {idAddPopUp ? (
        <div
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            backgroundColor: colors.white,
            WebkitBoxShadow: "0px 0px 7px 2px #00000040",
            minHeight: 300,
            maxHeight: 1300,
            minWidth: 400,
            maxWidth: 400,
            borderRadius: 8,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              marginTop: 10,
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ minWidth: 10 }} />
            <BaseButtons
              label={"X"}
              width={40}
              backgroundColor={colors.orangeDark}
              color={colors.white}
              onClick={() => setIdAddPopUp(false)}
              borderRadius={4}
            />
            <div style={{ fontWeight: "bold", marginLeft: 20 }}>
              ADD NEW PROXY/REPRESENTITIVE
            </div>
          </div>
          <div style={{ width: "90%", textAlign: "center", marginTop: 20 }}>
            This is for you to add mulitple Proxy to the same business you will
            then be able to assign a proxy on the ids page...
          </div>
          <TextInputField
            labelTitle={"ID NUMBER"}
            size={"90%"}
            width={"90%"}
            invert={true}
          />
          <TextInputField
            labelTitle={"First Name"}
            size={"90%"}
            width={"90%"}
            invert={true}
          />
          <TextInputField
            labelTitle={"Last Name"}
            size={"90%"}
            width={"90%"}
            invert={true}
          />
          <TextInputField
            labelTitle={"Cell Number"}
            size={"90%"}
            width={"90%"}
            invert={true}
          />
          <TextInputField
            labelTitle={"Email"}
            size={"90%"}
            width={"90%"}
            invert={true}
          />
          <TextInputField
            labelTitle={"Location"}
            size={"90%"}
            width={"90%"}
            invert={true}
          />
          <div style={{ minHeight: 20 }} />
          <BaseButtons
            label={"SUBMIT"}
            width={"90%"}
            backgroundColor={colors.primaryBlue}
            borderRadius={8}
          />
          <div style={{ minHeight: 20 }} />
        </div>
      ) : null}
      <div
        style={{
          height: height - 130,
          width: width - 215,

          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          overflowY: "hidden",
          overflowX: "hidden",
          scrollbarWidth: "thin",
        }}
      >
        {/* {selectedId ? (
          <div
            style={{
              maxWidth: 400,
              minWidth: 400,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              height: "99%",
              backgroundColor: colors.white,
              WebkitBoxShadow: "0px 0px 7px 2px #00000040",
              marginLeft: 5,
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            <div
              style={{
                width: 350,
                marginTop: 20,
                fontWeight: "bold",
                fontSize: 20,
              }}
            >
              ID VIEW & MANAGE
            </div>
            <div style={{ width: 350, marginTop: 20 }}>
              this is a explanation blurb of what this section is and how to
              manage it
            </div>

            <TextInputField
              labelTitle={"BUSINESS ID"}
              mini={true}
              width={"90%"}
              size={"90%"}
            />

            <TextInputField
              labelTitle={"ENATIS ID NUMBER"}
              mini={true}
              width={"90%"}
              size={"90%"}
            />
            {/* <div style={{width:350}}>
           agencyId 
         </div> */}

        {/* // list */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            height: "99%",
            // backgroundColor: colors.white,
            // WebkitBoxShadow: "0px 0px 7px 2px #00000040",
            marginLeft: 5,
          }}
        >
          {/* // this sis the header */}
          <div
            style={{
              width: "100%",
              marginTop: 0,
              backgroundColor: colors.secondaryDarkBlue,
              color: colors.white,
              minHeight: 40,
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* businessId */}
            {/* agencyId */}
            {/* isThisABranch */}
            <div
              style={{
                flex: 0.2,
                display: "flex",
                alignItems: "center",
                height: "100%",
              }}
            >
              <div style={{ marginLeft: 10, fontSize: 12 }}>ID NUMBER</div>
            </div>
            <div
              style={{
                flex: 0.2,
                display: "flex",
                alignItems: "center",
                height: "100%",
              }}
            >
              <div style={{ marginLeft: 10, fontSize: 12 }}>BRANCH NAME</div>
            </div>
            <div
              style={{
                flex: 0.2,
                display: "flex",
                alignItems: "center",
                height: "100%",
              }}
            >
              <div style={{ marginLeft: 10, fontSize: 12 }}>PROXY</div>
            </div>
            <div
              style={{
                flex: 0.2,
                display: "flex",
                alignItems: "center",
                height: "100%",
                justifyContent: "center",
              }}
            >
              <div style={{ marginLeft: 10, fontSize: 12 }}>CREATED</div>
            </div>
            <div
              style={{
                flex: 0.2,
                display: "flex",
                alignItems: "center",
                height: "100%",
                justifyContent: "center",
              }}
            >
              <div style={{ marginLeft: 10, fontSize: 12 }}>EDIT ON</div>
            </div>
            {/* proxyId */}
            {/* createdBy */}
          </div>
          {/* this is the list */}
          <div
            onClick={() =>
              setSelectedId(selectedId ? null : { name: "Test tester" })
            }
            style={{
              width: "100%",
              marginTop: 0,
              backgroundColor: colors.white,
              color: colors.secondaryDarkBlue,
              minHeight: 40,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            {/* businessId */}
            {/* agencyId */}
            {/* isThisABranch */}
            <div
              style={{
                flex: 0.2,
                display: "flex",
                alignItems: "center",
                height: "100%",
              }}
            >
              <div style={{ marginLeft: 10, fontSize: 12 }}>ID NUMBER</div>
            </div>
            <div
              style={{
                flex: 0.2,
                display: "flex",
                alignItems: "center",
                height: "100%",
              }}
            >
              <div style={{ marginLeft: 10, fontSize: 12 }}>BRANCH NAME</div>
            </div>
            <div
              style={{
                flex: 0.2,
                display: "flex",
                alignItems: "center",
                height: "100%",
              }}
            >
              <div style={{ marginLeft: 10, fontSize: 12 }}>PROXY</div>
            </div>
            <div
              style={{
                flex: 0.2,
                display: "flex",
                alignItems: "center",
                height: "100%",
                justifyContent: "center",
              }}
            >
              <div style={{ marginLeft: 10, fontSize: 12 }}>CREATED</div>
            </div>
            <div
              style={{
                flex: 0.2,
                display: "flex",
                alignItems: "center",
                height: "100%",
                justifyContent: "center",
              }}
            >
              <div style={{ marginLeft: 10, fontSize: 12 }}>EDIT ON</div>
            </div>
            {/* proxyId */}
            {/* createdBy */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProxyManagement;
